/**
 * Created by mariushirjanu on 12/05/2020.
 *
 * This file is the main entry point for the entire app
 */

import { ApplicationRef, NgModuleRef, enableProdMode, NgZone } from '@angular/core';
import { UrlService } from '@uirouter/angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { createNewHosts } from '@angularclass/hmr';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const bootstrap:() => Promise<NgModuleRef<any>> = () => platformBrowserDynamic().bootstrapModule(AppModule);
if (environment.hmr) {
  if (module[ 'hot' ]) {
    const hmrBootstrap = (
      module:any,
      bootstrap:() => Promise<NgModuleRef<any>>
    ) => {
      let ngModule:NgModuleRef<any>;
      module.hot.accept();
      bootstrap().then(mod => (ngModule = mod));
      module.hot.dispose(() => {
        const appRef:ApplicationRef = ngModule.injector.get(ApplicationRef);
        const elements = appRef.components.map(c => c.location.nativeElement);
        const makeVisible = createNewHosts(elements);
        ngModule.destroy();
        makeVisible();
      });
    };

    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --dev flag for ng serve?');
  }
} else {

  bootstrap()
    .then((platformRef:NgModuleRef<any>) => {

      // get() UrlService from DI (this call will create all the UIRouter services)
      const urlService:UrlService = platformRef.injector.get(UrlService);

      // Instruct UIRouter to listen to URL changes
      function startUIRouter():void {
        urlService.listen();
        urlService.sync();
      }

      const ngZone:NgZone = platformRef.injector.get(NgZone);
      ngZone.run(startUIRouter);

    })
    .catch(err => console.log(err));

}